export default {
  async loadAppError({dispatch}, error) {
    dispatch('mixpanelTrack', ['Load App Error', {
      'Error Message': error
    }])
  },
  async googleLogin({dispatch}) {
    dispatch('mixpanelTrack', ['Google Login'])
  },
  async authentication({dispatch}, [name, type]) {
    dispatch('mixpanelTrack', [name, {
      type
    }])
  },
  async loginError({dispatch}, [user, error]) {
    dispatch('mixpanelTrack', ['Login Error', {
      'User': user,
      'Error Code': error.code,
      'Error Message': error.message,
      // 'Email Login enabled': canLoginWithEmail
    }])
  },
  async registerError({dispatch}, [user, error]) {
    dispatch('mixpanelTrack', ['Signup Error', {
      'User': user,
      'Error Code': error.code,
      'Error Message': error.message
    }])
  },
  async logout({dispatch}) {
    dispatch('mixpanelTrack', ['Logout'])
  },
  async passwordReset({dispatch}) {
    dispatch('mixpanelTrack', ['Password Reset'])
  },
  async passwordResetError({dispatch}, [error]) {
    dispatch('mixpanelTrack', ['Password Reset Error', {
      'Code': error.code,
      'Message': error.message
    }])
  },

  //guest
  async createGuestAccount({dispatch}, [userId, token]) {
    dispatch('mixpanelTrack', ['Create Guest Account', {
      'User Id': userId,
      'Token': token
    }])
  },
  async loginAsGuest({dispatch}, [userId, token, returnData]) {
    dispatch('mixpanelTrack', ['Login As Guest', {
      'User Id': userId,
      'Token': token,
      'Return Data': returnData
    }])
  },
  async logoutGuestOnDisconnect({dispatch}) {
    dispatch('mixpanelTrack', ['Logout Guest on Disconnect'])
  },
}
